import React from "react";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { Form, Button } from "antd";
import { INPUT_TYPES } from "constants/input-types";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";
import "styles/form.css";
import moment from "moment";
import {
    RECEIVED_DOCUMENTS, PAYEE_NAME, SENDER_TYPE,
    RECEIVED_BY, PENDENCY, PENDENCY_REASON, COURIER_COMPANY
} from "constants/enums";
const FormItem = Form.Item;
const addPODDetails = new OrderedMap({
    pod_num: {
        type: INPUT_TYPES.TEXT,
        placeholder: "POD No.",
        label: "POD No.",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    date: {
        type: INPUT_TYPES.DATE,
        label: "Date",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    // // courier_company_name: {
    // //     type: INPUT_TYPES.TEXT,
    // //     placeholder: "Courier Company",
    // //     label: "Courier Company",
    // //     rules: [
    // //         {
    // //             required: true,
    // //             message: "Field is required"
    // //         }
    // //     ]
    // // },
    location: {
        type: INPUT_TYPES.TEXT,
        placeholder: "Location",
        label: "Location",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ]
    },
    received_docs_list: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Received Docs",
        label: "Received Docs",
        options: RECEIVED_DOCUMENTS.map((value, key) => ({
            label: key,
            value
        })).toList(),
        mode: "multiple",
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
    payee_name: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Payee Name",
        label: "Payee Name",
        options: PAYEE_NAME.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
    cheque_count: {
        type: INPUT_TYPES.TEXT,
        placeholder: "Cheque Count",
        label: "Cheque Count",
        rules: [
            {
                required: true,
                message: "Field is required"
            },
            {
                pattern: "^([0-9]|10)$",
                message: "Value should lie between 0-10",
            },
        ],
    },
    sender_type: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Sender Type",
        label: "Sender Type",
        options: SENDER_TYPE.map((value, key) => ({
            label: key,
            value
        })).toList(),
    },
    received_by: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Received By",
        label: "Received By",
        options: RECEIVED_BY.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
    pendency: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Pendency",
        label: "Pendency",
        options: PENDENCY.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
    pendency_reason: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Pendency Docs",
        label: "Pendency Docs",
        options: PENDENCY_REASON.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
    courier_company: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Courier Company",
        label: "Courier Company",
        options: COURIER_COMPANY.map((value, key) => ({
            label: key,
            value
        })).toList(),
        rules: [
            {
                required: true,
                message: "Field is required"
            }
        ],
    },
});

class PSKIT_POD_FORM extends React.Component {
    state={
        pendencyOnChangeValue: this.props.values?.toJS()?.pendency,
    }
    componentDidUpdate() {
        let amount = this.props.form.getFieldValue("amount");
        if(this.props.processing_fee_amount && !amount) {
            this.props.form.setFieldsValue({
                amount: this.props.processing_fee_amount
            });
        }
    }

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    save = () => {
        this.props.form.validateFields((err, values) => {
            if(!err) {
                this.props.update({...values, date: values.date && values.date.format("YYYY-MM-DD")});
            }

        });
    }

    render() {
        return (
            <Form>
                <div className={"form-row justify-content-space-between"}>
                    {addPODDetails
                        .map((field, fieldName) => {
                            if(fieldName === "pendency"){
                                field.onChange = (value) => this.setState({pendencyOnChangeValue:value});
                            }
                            if(this.state.pendencyOnChangeValue === 2 && fieldName === "pendency_reason"){
                                return false;
                            }
                            return this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )();
                        })
                        .toList()
                        // .toJS()}
                    }
                </div>
                <FormItem className={"d-flex justify-content-flex-end"}>
                    <Button
                        type="primary"
                        icon={"plus"}
                        onClick={this.save}
                    >
                        Save
                    </Button>
                </FormItem>
            </Form>
        );
    }
}

PSKIT_POD_FORM.propTypes = {
    form: PropTypes.object,
    update: PropTypes.func,
    processing_fee_amount: PropTypes.number,
    values: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values }) =>{
        return (
            values &&
    Object.keys(values).length &&
    (values)
        .map((value, key) => {
            if (key === "date") {
                let format = value && (value._isAMomentObject ? value : "YYYY-MM-DD");
                if(key === "pendency_reason"){
                    if(value === 0){
                        return Form.createFormField({
                            value: null
                        });
                    }
                }
                return Form.createFormField({
                    value:
                        value &&
                        (value._isAMomentObject ? value : moment(value, format).isValid() ? moment(value, format) : null)
                });
            }
            if(key ==="cheque_count"){
                return Form.createFormField({
                    value: String(value)
                });
            }
            return Form.createFormField({
                value
            });
        })
        .toJS()
        );}
})(PSKIT_POD_FORM);
